import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '@chargify/icons';

const spinTransition = {
  repeat: Infinity,
  ease: 'linear',
  duration: 1,
};

type LoaderProps = {
  /**
   * loader size
   */
  size?: number;
  /**
   * loader color
   */
  fill?: string;
};

const Loader = ({ size = 24, fill = 'gray.main' }: LoaderProps) => (
  <motion.span
    style={{
      display: 'inline-flex',
      transformOrigin: '50% 50%',
    }}
    animate={{ rotate: 360 }}
    transition={spinTransition}
  >
    <Icon fill={fill} size={size} type="spinner" />
  </motion.span>
);

export default Loader;
